<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <px-cotacao-produto-cancelar :cotacao="cotacao"
                                   :cotacao-produto="cotacaoProduto"
                                   @update="emitUpdate"/>
      <v-list-item :disabled="!isFinalizado || loadingLink"
                   @click="onClickVerCompra">
        <v-list-item-icon>
          <v-icon>mdi-open-in-new</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Ver compra</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import CotacaoProdutoService from '@/modules/cotacao/cotacao-produto-service';
import CotacaoProdutoCancelar from './CotacaoProdutoCancelar.vue';

export default {
  props: {
    cotacao: Object,
    cotacaoProduto: Object,
  },
  data() {
    return {
      loadingLink: false,
    };
  },
  computed: {
    isFinalizado() {
      return this.cotacaoProduto.situacao === SituacaoCotacao.keys.FINALIZADA.key;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    onClickVerCompra() {
      this.loadingLink = true;
      CotacaoProdutoService.getCompra(this.cotacao.id, this.cotacaoProduto.id)
        .then(({ data }) => {
          const routeData = this.$router.resolve({
            name: 'main.compras.detalhes',
            params: { id: data.id },
          });
          window.open(routeData.href, '_blank');
        })
        .finally(() => {
          this.loadingLink = false;
        });
    },
  },
  components: {
    pxCotacaoProdutoCancelar: CotacaoProdutoCancelar,
  },
};
</script>
